'use client';

import { useEffect, useRef } from 'react';

import { slideToActiveParams } from './carousel.types';

interface NewPaginationProps {
  max: number;
  active: number;
  slideToActive: (params: slideToActiveParams) => void;
}

export function PaginationCarousel({
  max,
  slideToActive,
  active,
}: NewPaginationProps) {
  const containerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (active > 3 && max > 5 && active < max) {
      containerRef.current &&
        containerRef.current.scrollTo({
          left: 20 * (active - 4),
          behavior: 'smooth',
        });
    }
  }, [max, active, containerRef]);
  return (
    <div
      className='slider-pagination scroll-smooth duration-300'
      ref={containerRef}
      role='tablist'
    >
      {Array.from({ length: max })?.map((el, index) => {
        return (
          <div
            className='slider-button snap-start'
            role='tab'
            tabIndex={0}
            aria-selected={index === active}
            onClick={() => slideToActive(index)}
            key={'pagination' + index}
          />
        );
      })}
    </div>
  );
}

export default PaginationCarousel;
